import { Fab } from "@mui/material";
import { ArrowUpwardOutlined } from "@mui/icons-material";
import { AppColors } from "../../Styles/colors";

const fabStyle = {
  position: "sticky",
  bottom: 10,
  left: '100%',
  marginRight: '10px',
  backgroundColor: AppColors.decorative.blueDark ,
};

export default function FabBackToTop() {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <Fab
      style={fabStyle}
      color="primary"
      onClick={handleClick}
      aria-label="back to top"
    >
      <ArrowUpwardOutlined />
    </Fab>
  );
}
